import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const pointestimates = 
{
    namespaced: true,
    state: {
        pointestimates: [],
        pointestimate: {}
    },
    mutations: {
        SET_POINTESTIMATES(state, data)
        {
            state.pointestimates = data
        },
        SET_POINTESTIMATE(state, data)
        {
            state.pointestimate = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GHSPointEstimate', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_POINTESTIMATES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePointEstimate({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePointEstimate({ commit }, {id, data}){
            return axios
            .post(baseUrl+'GHSPointEstimate/updatePointEstimate/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPointEstimate ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPointEstimate ({ commit }, data) {
            return axios
            .post(baseUrl+'GHSPointEstimate/addPointEstimate', data, { withCredentials: true },)
            .then(res => {
                console.log("point estimate added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default pointestimates